module.exports = __webpack_public_path__ + "static/media/Logo Archivo.937ed994.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/Logo Archivo.svg
// module id = 154
// module chunks = 0